(() => {
  function init(root = document) {
    root.querySelectorAll('[data-custom-manufacturing]').forEach((page) => {
      if (page.dataset.cmReady) return;
      page.dataset.cmReady = 'true';
      const form = page.querySelector('[data-cm-form]');
      if (!form) return;
      const type = form.querySelector('[data-cm-type]');
      page.querySelectorAll('[data-cm-project]').forEach((link) => {
        link.addEventListener('click', () => {
          if (type) {
            type.value = link.dataset.cmProject;
            const details = type.closest('[data-cm-details]');
            if (details) details.open = true;
          }
        });
      });
      const brief = form.querySelector('[data-cm-brief]');
      if (brief) {
        form.addEventListener('submit', (event) => {
          if (!brief.value.trim()) {
            event.preventDefault();
            brief.setCustomValidity('Please tell us a little about what you need.');
            brief.reportValidity();
          }
        });
        brief.addEventListener('input', () => brief.setCustomValidity(''));
      }
      const feedback = form.querySelector('.cm-form-feedback');
      if (feedback) feedback.focus({ preventScroll: false });
    });
  }
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
